// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__mVL35","svg":"Loader_svg__WmBU6","circular-rotate":"Loader_circular-rotate__rOUNI","svgSport":"Loader_svgSport__A1yEL"};